"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _snack = _interopRequireDefault(require("../views/snack.c"));

var _context = _interopRequireDefault(require("../context"));

function template() {
  var _this = this;

  var snacks = this.state.snacks;
  return _react["default"].createElement(_react["default"].Fragment, null, snacks.map(function (snack) {
    return _react["default"].createElement(_snack["default"], (0, _extends2["default"])({
      key: snack.id
    }, _this.props, snack, {
      setSnackHeight: _this.setSnackHeight,
      onClose: _this.hideSnack,
      onHideEnd: function onHideEnd() {
        return _this.onHideEnd(snack.id);
      },
      onMoveEnd: function onMoveEnd() {
        return _this.onMoveEnd(snack.id);
      }
    }));
  }), _react["default"].createElement(_context["default"].Provider, {
    value: this.addSnack
  }, this.props.children));
}